import PropTypes from "prop-types";
import { useEffect } from "react";
// @mui
import { Box, Drawer, Stack } from "@mui/material";
// hooks
import { useResponsive } from "src/hooks/use-responsive";
// routes
import { usePathname } from "src/routes/hook";
// components
import Logo from "src/components/logo";
import Scrollbar from "src/components/scrollbar";
import { NavSectionVertical } from "src/components/nav-section";
//
import { NAV } from "../config-layout";
import { useNavData } from "./config-navigation";
import { NavDocs } from "../_common";

// ----------------------------------------------------------------------

NavVertical.propTypes = {
    onCloseNav: PropTypes.func,
    openNav: PropTypes.bool,
    hasPayFailed: PropTypes.bool,
    bannerHeight: PropTypes.number
};

export default function NavVertical({ openNav, onCloseNav, hasPayFailed, bannerHeight }) {
    const pathname = usePathname();

    const lgUp = useResponsive("up", "lg");

    const navData = useNavData();

    useEffect(() => {
        if (openNav) {
            onCloseNav();
        }
    }, [pathname]);

    const renderContent = (
        <Scrollbar
            sx={{
                height: 1,
                backgroundColor: "#FFF",
                position: "relative",
                "& .simplebar-content": {
                    height: 1,
                    display: "flex",
                    flexDirection: "column"
                }
            }}
        >
            <Logo sx={{ mt: 2.5, ml: 2.5, mb: 1 }}/>

            <NavSectionVertical data={navData}/>

            <Box sx={{ flexGrow: 1 }}/>

            <NavDocs/>
        </Scrollbar>
    );

    return (
        <Box
            component="nav"
            sx={{
                flexShrink: { lg: 0 },
                width: { lg: NAV.W_VERTICAL },
                backgroundColor: (theme) => `${theme.palette.background.default}`,
                zIndex: theme => theme.zIndex.appBar + 2
            }}
        >
            {lgUp ? (
                <Stack
                    sx={{
                        height: hasPayFailed ? `calc( 100vh - ${bannerHeight}px)` : 1,
                        position: "fixed",
                        width: NAV.W_VERTICAL,
                        borderRight: (theme) => `dashed 1px ${theme.palette.divider}`
                    }}
                >
                    {renderContent}
                </Stack>
            ) : (
                <Drawer
                    open={openNav}
                    onClose={onCloseNav}
                    PaperProps={{
                        sx: {
                            width: NAV.W_VERTICAL
                        }
                    }}
                >
                    {renderContent}
                </Drawer>
            )}
        </Box>
    );
}
